import { css } from '@/styled-system/css';

export const skeletonContainer = css({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'bg.neutral',
  position: 'relative',
  minHeight: '100vh',
  '@supports (min-height: 100dvh)': {
    minHeight: '100dvh',
  },
  lg: {
    minHeight: 'unset',
    height: '100%',
    overflow: 'hidden',
  },
});

export const skeletonMain = css({
  flex: 1,
  position: 'relative',
  lg: {
    overflow: 'auto',
  },
});

export const skeletonGalleryPadding = css({
  lg: {
    paddingInline: 'looser',
  },
});

export const skeletonGalleryContainer = css({
  position: 'relative',
  width: '100%',
});

// Mobile: full-width 4:3 carousel placeholder
export const skeletonMobileCarousel = css({
  display: 'block',
  width: '100%',
  aspectRatio: '4/3',
  backgroundColor: 'bg.softest',
  lg: {
    display: 'none',
  },
});

// Desktop: bento grid skeleton matching the 4-photo layout
export const skeletonBentoGrid = css({
  display: 'none',
  lg: {
    display: 'grid',
    gap: 'tighter',
    // eslint-disable-next-line hotpads/no-magic-numbers, constellation/no-raw-spacing-values -- fixed desktop hero-gallery skeleton artboard height
    height: '510px',
    borderRadius: 'md',
    overflow: 'hidden',
    gridTemplateColumns: 'repeat(10, 1fr)',
    gridTemplateRows: '1fr 1fr',
    '& > *:nth-child(1)': { gridColumn: 'span 6' },
    '& > *:nth-child(2)': { gridColumn: 'span 4' },
    '& > *:nth-child(3)': { gridColumn: 'span 4' },
    '& > *:nth-child(4)': { gridColumn: 'span 6' },
  },
});

export const skeletonBentoCell = css({
  backgroundColor: 'bg.softest',
});

// Mirrors the frosted desktop controls that overlay the gallery.
export const skeletonDesktopHeader = css({
  display: 'none',
  lg: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    padding: 'default',
    gap: 'default',
    zIndex: 'zIndexStep',
  },
});

export const skeletonHeaderBarLeft = css({
  justifySelf: 'start',
  height: '800',
  width: '800',
  borderRadius: 'pill',
  backgroundColor: 'bg.softest',
});

export const skeletonHeaderBarCenter = css({
  display: 'none',
});

export const skeletonHeaderBarRight = css({
  justifySelf: 'end',
  height: '800',
  width: '1800',
  borderRadius: 'md',
  backgroundColor: 'bg.softest',
});

export const skeletonContentPadding = css({
  paddingLeft: 'default',
  paddingRight: 'default',
  paddingTop: 'default',
  lg: {
    paddingLeft: 'looser',
    paddingRight: 'looser',
  },
});

export const skeletonBar = css({
  height: '350',
  borderRadius: 'sm',
  backgroundColor: 'bg.softest',
  marginBottom: 'tighter',
});
